import { gql } from '@apollo/client';

export const SEND_SINGLE_PRIORITY_TRANSACTION = gql`
mutation sendSinglePriorityTransaction($token : String!,$paymentdata:CustomerPayment!) {
  sendSinglePriorityTransaction(token: $token, paymentdata:$paymentdata) {
    status
    data
    error
  }
}
`;

export const SEND_PRIORITY_VERIFICATION_TRANSACTIONS = gql`
mutation sendPriorityVerificationTransactions($phone : String!) {
  sendPriorityVerificationTransactions(phone: $phone) {
    status
    data
    error
  }
}
`;

export const CONIFRM_PRIORITY_VERIFICATION_TRANSACTIONS = gql`
mutation verifyTempPriorityTransactions($phone : String!, $amount1 : Float!) {
  verifyTempPriorityTransactions(phone: $phone, amount1: $amount1) {
    status
    data
    error
  }
}
`;